import React from 'react'
import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { CheckIcon, XMarkIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import Button from '../button/Button'

export default function Modal({title, subtext, cancelButton, confirmButtonAction, confirmButtonText, icon="success", onCancel}) {
  const [open, setOpen] = useState(true)

  return (
    <Dialog open={open} onClose={() => {}} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-[400px] sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div>
              { icon === 'success' && (
                <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
                  <CheckIcon aria-hidden="true" className="size-6 text-green-600" />
                </div>
              )}
              { icon === 'error' && (
                <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-red-100">
                  <XMarkIcon aria-hidden="true" className="size-6 text-red-600" />
                </div>
              )}
              { icon === 'warning' && (
                <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-yellow-100">
                  <ExclamationTriangleIcon aria-hidden="true" className="size-6 text-yellow-600" />
                </div>
              )}
              <div className="mt-3 text-center sm:mt-5">
                <DialogTitle as="h3" className="text-base font-semibold text-gray-900" title={title}>
                  {title}
                </DialogTitle>
                {subtext && (
                    <div className="mt-2">
                    <p className="text-sm text-gray-500">
                        {subtext}
                    </p>
                    </div>
                )}
              </div>
            </div>
            <div className="mt-7 flex">
              {cancelButton && (
                <Button
                  type="button"
                  onClick={onCancel}
                  className="w-full mx-1"
                  buttonClassName="w-full"
                  color="gray-200" text="gray-800"
                >
                  Cancel
                </Button>
              )}
              <Button
                type="button"
                onClick={confirmButtonAction ? confirmButtonAction : () => setOpen(false)}
                className="w-full mx-1"
                buttonClassName="w-full"
              >
                {confirmButtonText ? confirmButtonText : 'Close'}
              </Button>
              
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
